/**
 * Нижняя навигация между картой, героем, домом, кошельком и долгами (§15).
 *
 * Назначение файла: собрать список разделов с подписями из @hive/i18n и отдать
 * его «жидкой» плите (ui/nav/LiquidNav.tsx). Вид и анимация — там, здесь состав.
 */

import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import { LiquidNav, type LiquidNavItem } from "./nav/LiquidNav.jsx";
import "./nav/nav.css";

export type AppTab = "map" | "hero" | "hearth" | "wallet" | "debt";

export interface AppNavProps {
  readonly active: AppTab;
  readonly onChange: (tab: AppTab) => void;
  readonly showDebt?: boolean;
}

export function AppNav({ active, onChange, showDebt = false }: AppNavProps): React.JSX.Element {
  const { t } = useTranslation("common");

  const items = useMemo<LiquidNavItem[]>(() => {
    const base: LiquidNavItem[] = [
      { id: "map", icon: "map", label: t("nav.map") },
      { id: "hero", icon: "hero", label: t("nav.hero") },
      { id: "hearth", icon: "hearth", label: t("nav.hearth") },
      { id: "wallet", icon: "wallet", label: t("nav.wallet") },
    ];
    // Раздел долгов появляется только при долге: пустой раздел пугает новичка.
    if (showDebt) {
      base.push({ id: "debt", icon: "debt", label: t("nav.debts") });
    }
    return base;
  }, [showDebt, t]);

  return (
    <LiquidNav
      items={items}
      activeId={active}
      ariaLabel={t("nav.main")}
      onChange={(id) => onChange(id as AppTab)}
    />
  );
}
